import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import API from "../Services/Report";
import * as XLSX from "xlsx";

const PaymentCollection = ({ filters, selectedCenter, resetTrigger, applyTrigger }) => {
    const [payment, setPayment] = useState([]);
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 90);
    const formattedPastDate = pastDate.toISOString().split("T")[0];

    const getPaymentSummerReport = async () => {
        try {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            const payloadData = {

                start_date: filters.startDate || formattedPastDate,
                end_date: filters.endDate || formattedToday,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
            };

            const response = await API.getPaymentSummryReport(payloadData);

            if (response?.status === 200 && Array.isArray(response?.data?.result)) {
                setPayment(response.data.result);
            } else {
                toast.error(response?.data?.message || "No finance report found");
                setPayment([]);
            }
        } catch (error) {
            toast.error("Something went wrong while fetching report");
        }
    };

    useEffect(() => {
        if (applyTrigger === 0 && resetTrigger === 0) return;
        getPaymentSummerReport();
    }, [applyTrigger, resetTrigger]);

    return (
        <div className="modern-table-container">
            <div className="modern-table-header">
                <div className="modern-table-title">
                    Payment Collection ({payment.length})
                </div>
            </div>

            <div className="p-4">

                <div className="row g-3">

                    {payment.length > 0 ? (
                        payment.map((item, index) => (
                            <div className="col-md-4" key={index}>
                                <div
                                    className="card shadow-sm border-0 h-100"
                                    style={{
                                        borderRadius: "14px",
                                        transition: "0.3s",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-5px)";
                                        e.currentTarget.style.boxShadow =
                                            "0 6px 20px rgba(0,0,0,0.15)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0px)";
                                        e.currentTarget.style.boxShadow = "";
                                    }}
                                >
                                    <div
                                        className="card-header text-white"
                                        style={{
                                            background: "#4361ee",
                                            borderRadius: "10px 10px 0 0",
                                        }}
                                    >
                                        <h5 className="mb-0 fw-bold">{item?.payment_type}</h5>
                                    </div>

                                    <div className="card-body">

                                        <div className="d-flex justify-content-between mb-2">
                                            <span>Amount:</span>
                                            <span className="fw-bold text-success">
                                                ₹{item?.amount}
                                            </span>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <span>Percentage:</span>
                                            <span className="badge bg-warning text-dark px-3 py-2">
                                                {item?.percentage}%
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-12 text-center mt-5">
                            <h6 className="text-muted">No data available</h6>
                        </div>
                    )}
                </div>

            </div>
        </div>
    );
};

export default PaymentCollection;
